import {useSelector} from 'react-redux'
import {KeyIcon, ArrowLeftIcon} from '../../../icons'
import {SimpleBlueButton} from '../../core/button'
import Text from '../../../utils/text'
import SkeletonLoader from '../../core/skeletonLoader'
import {MFA_STEPS} from '../../../stores/security'
import {colors} from '../../../utils/colors'

const SKELETON_COUNT = 10

const RecoveryCodesView = ({text, recoveryCodes, step, onDone, onRegenerate}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const isRegenerating = step === MFA_STEPS.REGENERATING_CODES

    const handleCopyAll = () => {
        Text.copyText(recoveryCodes.join('\n'))
    }

    const handleDownload = () => {
        const content = recoveryCodes.join('\n')
        const blob = new Blob([content], {type: 'text/plain'})
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'recovery-codes.txt'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
    }

    return (
        <div className='security-card'>
            <div className='mfa-setup'>
                <div className='mfa-setup-header'>
                    <button
                        type='button'
                        className='mfa-back-button'
                        onClick={onDone}
                        aria-label={text.recovery_codes_done}
                    >
                        <ArrowLeftIcon color={isDarkMode ? colors.colorFilterTitle : colors.colorMuted} />
                    </button>
                    <div className='security-icon'>
                        <KeyIcon opacity={1} fill="currentColor"/>
                    </div>
                    <h3 className='security-card-title'>{text.recovery_codes_title}</h3>
                </div>

                <div className='recovery-codes-body'>
                    <p className='recovery-codes-description'>{text.recovery_codes_description}</p>

                    <div className='recovery-codes-grid'>
                        {isRegenerating
                            ? Array.from({length: SKELETON_COUNT}).map((_, index) => (
                                <div key={index} className='recovery-code-item'>
                                    <SkeletonLoader className='recovery-code-skeleton' />
                                </div>
                            ))
                            : recoveryCodes.map((code, index) => (
                                <div key={index} className='recovery-code-item'>
                                    <span className='recovery-code-index'>{index + 1}</span>
                                    <code className='recovery-code-value'>{code}</code>
                                </div>
                            ))
                        }
                    </div>

                    <div className='recovery-codes-warning'>
                        <p>{text.recovery_codes_warning}</p>
                    </div>

                    <div className='recovery-codes-actions'>
                        <SimpleBlueButton outline onClick={handleDownload} disabled={isRegenerating}>
                            {text.download}
                        </SimpleBlueButton>
                        <SimpleBlueButton outline onClick={handleCopyAll} disabled={isRegenerating}>
                            {text.copy_all}
                        </SimpleBlueButton>
                        <SimpleBlueButton onClick={onDone}>
                            {text.recovery_codes_done}
                        </SimpleBlueButton>
                    </div>

                    <div className='recovery-codes-regenerate'>
                        <h4 className='recovery-codes-regenerate-title'>{text.generate_new_codes_title}</h4>
                        <p className='recovery-codes-regenerate-description'>{text.generate_new_codes_description}</p>
                        <SimpleBlueButton
                            outline
                            onClick={onRegenerate}
                            disabled={isRegenerating}
                        >
                            {text.generate_new_codes}
                        </SimpleBlueButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RecoveryCodesView
